<div fxLayout="row" class="prep-auth">
  <div fxLayout="column" class="page" fxFlex="55" fxHide.lt-md="true"></div>
  <main fxLayout="column" fxLayoutAlign="center center" style="background-color: rgb(255, 255, 255)" fxFlex="45"
    fxFlex.lt-md="100" class="elevation" fxLayoutGap="10px">
    <div fxFlex="20" fxLayoutAlign="start center" style="
        background-color: rgb(255, 255, 255);
        width: 100%;
        padding-left: 5%;font-size: x-large; font-weight: bold
      ">
      <img style="margin-right: 10px" src="../../../../assets/splash-screen/prep-icon.svg" alt="PREP logo"
        height="90" />
      PDF Remediation Platform
    </div>
    <div fxFlex="70" fxLayoutAlign="center center" style="width: 100%; padding-left: 5%; padding-right: 5%">
      <div [@fadeInUp] class="card border-radius" style="height: 60vh">
        <form [formGroup]="UserLoginFormGroup" (ngSubmit)="send()">
          <div fxLayout="column">
            <div style="padding-bottom: 20px">
              <!-- <h1 *ngIf="SSOFlow">COLORADO SPRINGS USER LOGIN</h1> -->
              <img *ngIf="SSOFlow" src="../../../../assets/Logo/miami-university-logo.png" height="90">
              <h1>USER LOGIN</h1>
              <h2 *ngIf="!SSOFlow" style="color: #136ef8;font-size: 18px;font-weight: bold;">Welcome to PREP Console</h2>
            </div>

            <div *ngIf="!SSOFlow" fxFlex="auto" fxLayout="column">
              <small>Fields marked with an asterisk (*) are required.</small>
              <mat-form-field fxFlex="grow" appearance="outline">
                <mat-label>E-Mail</mat-label>
                <input matInput required formControlName="username" id="username" />
                <mat-error *ngIf="
                UserLoginFormGroup.get('username')?.hasError('required')
              ">Please enter your email address
                </mat-error>
                <mat-error *ngIf="
                UserLoginFormGroup.get('username')?.hasError('email')
              ">Please enter a valid email address
                </mat-error>
              </mat-form-field>


              <mat-form-field fxFlex="grow" appearance="outline" style="margin-top: 7px;">
                <mat-label>Password</mat-label>
                <input matInput [type]="inputType" formControlName="password" id="password" required minlength="6" />

                <button type="button" mat-icon-button matSuffix (click)="toggleVisibility()"
                  [attr.aria-label]="visible ? 'Hide password' : 'Show password'" [attr.aria-pressed]="visible"
                  matTooltip="Show/Hide">
                  <mat-icon *ngIf="visible">visibility</mat-icon>
                  <mat-icon *ngIf="!visible">visibility_off</mat-icon>
                </button>
                <mat-hint style="color: black;">Click the eye to toggle visibility</mat-hint>
                <mat-error *ngIf="UserLoginFormGroup.get('password').hasError('required')">
                  We need a password to log you in
                </mat-error>

                <mat-error *ngIf="UserLoginFormGroup.get('password').hasError('minlength')">
                  The password should be minimum 6 characters
                </mat-error>
              </mat-form-field>
            </div>


            <div *ngIf="!SSOFlow" fxLayout="row" fxLayoutAlign="space-between center" style="padding: 15px 0"
              role="group" aria-label="Login preferences">
              <mat-checkbox class="caption" aria-label="Remember me for future logins">
                Remember me
              </mat-checkbox>
              <a [routerLink]="['/forgot-password']" class="caption"
                aria-label="Forgot your password? Click to reset it">
                Forgot password?
              </a>
            </div>


            <button mat-raised-button color="primary" class="platform-login-button" type="submit" id="submit"
              [disabled]="UserLoginFormGroup.invalid || is_loading" aria-label="Sign in"
              [attr.aria-disabled]="UserLoginFormGroup.invalid || is_loading" [attr.aria-busy]="is_loading">
              <ng-container *ngIf="!is_loading; else loading">
                SIGN IN
              </ng-container>
              <ng-template #loading>
                Signing in...
              </ng-template>
            </button>



            <!-- <small style="text-align: center;margin-top: 30px;" role="note" aria-label="Privacy policy notice">Before
              clicking Log In you can review our company<br />
              <a style="text-decoration: underline;color: #136ef8;"
                href="https://prep.continualengine.com/privacy-policy/" target="_blank" rel="noopener noreferrer"
                aria-label="View our company's Privacy Policy in a new tab">Privacy
                Policy</a></small> -->


            <div style="text-align: center;margin-top: 30px;" role="note" class="privacy-note"
              aria-label="Privacy policy notice">
              <p>
                Before clicking Log In, you can review our company<br />
                <a href="https://prep.continualengine.com/privacy-policy/" target="_blank" rel="noopener noreferrer"
                  aria-label="View our company's Privacy Policy in a new tab">
                  Privacy Policy
                </a>
              </p>
            </div>




            <div fxLayout="row" fxLayoutAlign="center center" style="padding: 15px 0" role="status" aria-live="polite"
              aria-busy="true" *ngIf="is_loading">
              <mat-spinner color="primary" [diameter]="40" aria-label="Loading, please wait"></mat-spinner>
              <span class="cdk-visually-hidden">Loading, please wait</span>
            </div>

          </div>
        </form>
      </div>
    </div>
    <div fxFlex="10" fxLayoutAlign="center center" style="width: 100%; padding-left: 5%" role="contentinfo"
      aria-label="Branding section">
      <div fxLayout="column" style="text-align: center;">
        <span>Powered by</span>
        <img src="../../../../assets/Logo/ce-logo.svg" alt="Continual Engine logo" height="50" />
      </div>
    </div>
  </main>
</div>